<div class="l_flexbar">
  <div *ngIf="item" class="icon-container">
    <dgx-image-layout
      format="list"
      [imageSrc]="item.imageUrl || item.picture"
      [resourceId]="item.resourceId"
      [resourceType]="item.resourceType"
      [videoUrl]="item.resourceType === 'Video' ? item.url : ''"
      [providerImage]="item.providerSummary?.image"
    ></dgx-image-layout>
  </div>
  <div class="guts-p-r-half min-width-0 par par--small">
    <div class="l_flexbar font-semibold">
      <span class="block clamp">{{ title }}</span>
      <img
        class="block guts-m-l-half tag-endorsed-img v-bottom"
        *ngIf="endorsedSrc"
        src="{{ endorsedSrc }}"
        [attr.alt]="i18n.Core_Endorsed"
      />
    </div>
    <dl class="l_flexbar par--light">
      <dt class="a11y-hide">{{ i18n.dgOrgInternalContent_ContentType }}</dt>
      <dd>{{ description }}</dd>
      <ng-container *ngIf="isRemovable && !!item.durationDisplay">
        <dt class="a11y-hide">{{ i18n.Core_Duration }}</dt>
        <dd class="guts-m-l-3-quart">{{ item.durationDisplay }}</dd>
      </ng-container>
    </dl>
  </div>
  <div class="l_flex--align-right" *ngIf="isRemovable">
    <button
      type="button"
      [ngbTooltip]="i18n.Core_Remove"
      (click)="remove.emit(item)"
      [attr.aria-label]="ariaLabelForRemoveContent"
      data-dgat="content-result-6c4"
    >
      <df-icon icon="cross" size="medium"></df-icon>
    </button>
  </div>
</div>
